import { _update } from '@felte/common';

function validateSchema(schema) {
    function shapeErrors(errors) {
        return errors.issues.reduce((err, value) => {
            /* istanbul ignore next */
            if (!value.path)
                return err;
            return _update(err, value.path.join('.'), (currentValue) => {
                if (!currentValue || !Array.isArray(currentValue))
                    return [value.message];
                return [...currentValue, value.message];
            });
        }, {});
    }
    return async function validate(values) {
        try {
            await schema.parseAsync(values);
        }
        catch (error) {
            return shapeErrors(error);
        }
    };
}
function validator({ schema, level = 'error', }) {
    return function extender(currentForm) {
        if (currentForm.stage !== 'SETUP')
            return {};
        const validateFn = validateSchema(schema);
        currentForm.addValidator(validateFn, { level });
        return {};
    };
}

export { validateSchema, validator };
//# sourceMappingURL=index.mjs.map
